import {Component, OnInit} from '@angular/core';
import {BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-tile',
    templateUrl: './block-tile.component.html',
})

export class BlockTileComponent extends BlockAbstractComponent implements OnInit {

    isStyle2?: boolean;
    isStyle4?: boolean;
    isStyle5?: boolean;

    slideConfig = {
        loop: true,
        navigation: {
            nextEl: '.tile-controls__next',
            prevEl: '.tile-controls__prev'
        },
        pagination: {
            bulletActiveClass: 'tile-controls__indicator--active',
            bulletClass: 'tile-controls__indicator',
            clickable: true,
            el: '.tile-controls__indicator-wrapper',
        },
        slideClass: 'tile-item',
        wrapperClass: 'tile-container'
    };

    override ngOnInit() {
        super.ngOnInit();
        this.isStyle2 = this.block.data.style === 'style2';
        this.isStyle4 = this.block.data.style === 'style4';
        this.isStyle5 = this.block.data.style === 'style5';
    }

}
